export default __webpack_public_path__ + "images/a0f5a1adda45a4fcf0a3a6bf0945fba5-travel.webp";